module.exports = __webpack_public_path__ + "img/prev-left.984b5faf.svg";